import NotificationsConverter from './NotificationsConverter';
import NavigationConverter from './NavigationConverter';

export default { printWireToInt: printWireToInt };

function printWireToInt (data) {
  const { action, gototab, redirecturl, reservationid, settings, notifications } = data;

  let intAction = action ? action._text : '';
  let goToTab = gototab ? gototab._text : '';
  let redirectUrl = redirecturl ? redirecturl._cdata || redirecturl._text : '';
  let reservationId = reservationid ? reservationid._text : '';
  let navigation = NavigationConverter.navigationWireToInt(settings);
  let intNotifications = NotificationsConverter.notificationsWireToInt(notifications);

  return {
    action: intAction,
    reservationId,
    goToTab,
    redirectUrl,
    navigation,
    notifications: intNotifications,
  };
}



// WEBPACK FOOTER //
// ./src/converter/PrintConverter.js